import { Image } from "react-bootstrap";
import Moment from "react-moment";
import { FacebookIcon, LinkedinIcon, TwitterIcon } from "react-share";
import { TwitterShareButton, LinkedinShareButton, FacebookShareButton } from "react-share";
import { toast } from "react-toastify";
import { decodeHTMLEntities, parseHtml, toWebp } from "../../../utils/common";

function BlogDigital(props) {
    let block = props.block;
    let authors = props.authors;
    let blogBy = authors?.data?.map(a => a.attributes.fullname).join(", ");
    let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
    let url = process.env.NEXT_PUBLIC_REACT_APP_BASE_URL;


    const copyPageUrl = () => {
        navigator.clipboard.writeText(window.location.origin + window.location.pathname).then(() => {
            toast.success("Link Copied To Clipboard!");
        });
    }

    return (
        <>
            {block &&
                <section className="blog-digital-section bg-one home-padding-new ">
                    <div className="blog-digital-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="blog-digital-heading">
                                        <h1 className="h2">{decodeHTMLEntities(block.title)}</h1>
                                        {block.content ? parseHtml(block.content) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <ul className="blog-digital-date">
                                        <li><a href="#">By&nbsp;<strong> {blogBy}</strong></a></li>
                                        <li><a href="#">{block.time_to_read}</a></li>
                                        {block.publish_at ?
                                            <li>
                                                <a href="#">
                                                    <Moment format="MMM Do , YYYY">{block.publish_at}</Moment>
                                                </a>
                                            </li>
                                            :null}
                                    </ul>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <ul className="blog-digital-social">
                                        <li><span>Share Now</span></li>
                                        <li>
                                            <a href="#">
                                                <Image src={"/images/link.svg"} alt="link" onClick={() => copyPageUrl()} />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span>
                                                    <LinkedinShareButton url={url + block.slug} quote={decodeHTMLEntities(block.title)}>
                                                        <LinkedinIcon size={32} round />
                                                    </LinkedinShareButton>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span>
                                                    <TwitterShareButton url={url + block.slug} quote={decodeHTMLEntities(block.title)}>
                                                        <TwitterIcon size={32} round />
                                                    </TwitterShareButton>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <span>
                                                    <FacebookShareButton url={url + block.slug} quote={decodeHTMLEntities(block.title)}>
                                                        <FacebookIcon size={32} round />
                                                    </FacebookShareButton>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="blog-digital-img">

                                        <Image
                                            src={
                                                block?.image?.data
                                                    ? toWebp(`${baseUrl}${block?.image?.data?.attributes?.url}`)
                                                    : null
                                            }
                                            alt={
                                                block?.image?.data
                                                    ? `${block?.image?.data?.attributes?.alt}`
                                                    : null
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    );
}

export default BlogDigital;


